import '../../../base/css/base.pcss';
import '../../../base/js/base';

import '../../parts/header/index';
import '../../parts/footer/index';

/* shortcodes */
import '../../shortcodes/bordered-text-block/index';
import '../../shortcodes/text-with-solid-bg/index';

/* modules */

/* templates */
import '../../templates/page/index';
import '../../templates/with-case-studies-footer/index';

import './business-development-strategists.pcss';
import './business-development-strategists';